(function() {
    'use strict';

    angular
        .module('functional7App')
        .controller('MediaDetailController', MediaDetailController);

    MediaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Media'];

    function MediaDetailController($scope, $rootScope, $stateParams, previousState, entity, Media) {
        var vm = this;

        vm.media = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('functional7App:mediaUpdate', function(event, result) {
            vm.media = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
